export enum ThemeTypeList {
  TASK_EVA = "task-eva",
  USER_CENTER = "user-center",
}

export type ThemeType = `${ThemeTypeList}`;
